export const getSpecCharValue = (
  graphqlResponse: any,
  name: string
): string | undefined => {
  return graphqlResponse?.data?.getProductOfferByID?.[0]?.specCharValueUse
    ?.find((c: any) => c.name === name)
    ?.specCharacteristicValue?.[0]?.value;
};

export const getProductTitle = (graphqlResponse: any, lang: string): string => {
  const offer = graphqlResponse?.data?.getProductOfferByID?.[0];
  if (lang === 'ar' && offer?.offerLabels?.length > 0) {
    return offer.offerLabels[0]?.name ?? '';
  }
  return offer?.name ?? '';
};